import { type FirebaseApp, initializeApp } from "firebase/app";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { initializeFirestore, memoryLocalCache } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getDatabase } from "firebase/database";
import { config } from "./config";

// Export the firebase app instance in case it's needed by other modules.
export const firebaseApp: FirebaseApp = initializeApp(config.firebaseConfig);

// Export the firebase auth instance
export const firebaseAuth = getAuth(firebaseApp);

// Initialize Firestore with caching DISABLED to prevent "Target ID already exists" errors
// The localCache: memoryLocalCache() setting ensures no persistent storage is used
export const firestore = initializeFirestore(firebaseApp, {
  ignoreUndefinedProperties: true,
  localCache: memoryLocalCache() // Use in-memory cache only - no IndexedDB persistence
});

console.log("✅ Firestore initialized with memory-only cache (no persistence)");

// This is deprecated, use firestore instead
export const firebaseDb = firestore; // @deprecated

// Export the firebase storage instance
export const firebaseStorage = getStorage(firebaseApp);

// Export Firebase Realtime Database instance for video call signaling
export const realtimeDb = getDatabase(firebaseApp);
console.log("✅ Firebase Realtime Database initialized");

// Note: Global auth listener removed to prevent duplicate Firestore subscriptions
// Auth state is now managed centrally in AppProvider.tsx
